import { useRef, useState } from "react";

// His `toast`: one short line at the bottom of the screen, gone after a few seconds.
export function Toast({ message }: { message: string | null }) {
  if (!message) return null;
  return <div role="status" aria-live="polite" className="fixed bottom-5 left-1/2 z-50 -translate-x-1/2 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-medium text-white shadow-lg">{message}</div>;
}

export function useToast() {
  const [message, setMessage] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);
  const show = (m: string) => { setMessage(m); window.clearTimeout(timer.current); timer.current = window.setTimeout(() => setMessage(null), 3800); };
  return [message, show] as const;
}
